let estimates = 0;
let batchEstimateSize = 0;
let samples = [];
setInterval(() => {
    if (estimates > 500) {
        console.log(`set ${estimates} keys in redis last 10000ms (Combined size: ~${batchEstimateSize / 1024}kb, samples: ${samples})`);
    }
    estimates = 0;
    batchEstimateSize = 0;
    samples = [];
}, 10000);
export const logByteEstimate = (key, s) => {
    estimates += 1;
    const n = typeof s === 'string' ? s.length : s;
    const estimate = n * 1.5;
    batchEstimateSize += estimate;
    if (Math.log2(estimates) % 1 === 0) {
        samples.push(key);
    }
    if (n > 1_000_000) {
        console.log(`redis set size: ${key} | size: ~${estimate / 1024}kb`);
    }
};
//# sourceMappingURL=tmp.js.map